import mealActions from '../actionTypes/mealActions';

const initialState = {
  mealDetails: {},
};

const mealReducer = (state = initialState, action) => {
  switch (action.type) {
    case mealActions.getMealDetails:
      return { ...state, isLoading: true };
    case mealActions.getMealDetailsSuccess:
      return { ...state, mealDetails: action.payload.data, isLoading: false };
    case mealActions.getMealDetailsFailed:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default mealReducer;
